import React from 'react'

export default function NewsItem({id, date, title, message, link}) {
  return (
    <div key={id} className="news-item">
      <a className="title" {...link}>{`${date} - ${title}`}</a>
      <p className="content">{message}</p>
    </div>
  )
}
